<template>
  <div
    class="info-tooltip-container"
    ref="tooltip"
    @mouseenter="showTooltip"
    @mouseleave="scheduleTooltipHide"
  >
    <span class="info-icon">
      <img
        class="icon-in-button"
        :src="require('@/assets/dashboard/circle-info-solid-dark-grey.svg')"
        alt="Icon"
      />
    </span>
    <Teleport to="body">
      <div
        v-if="visible"
        ref="popup"
        class="info-popup"
        :class="{ 'info-popup-with-images': validImages.length }"
        :style="popupStyle"
        @mouseenter="cancelTooltipHide"
        @mouseleave="scheduleTooltipHide"
      >
        <div v-if="title" class="info-popup-title">{{ title }}</div>
        <div v-if="validImages.length" class="info-popup-images">
          <img
            class="info-popup-image"
            :src="currentImageSrc"
            :alt="`Hinweisbild ${currentImageIndex + 1}`"
          />
          <div v-if="validImages.length > 1" class="info-popup-image-navigation">
            <button
              type="button"
              class="info-popup-image-button"
              aria-label="Vorheriges Hinweisbild"
              @click.stop="prevImage"
            >
              ‹ Vorheriges Bild
            </button>
            <button
              type="button"
              class="info-popup-image-button"
              aria-label="Nächstes Hinweisbild"
              @click.stop="nextImage"
            >
              Nächstes Bild ›
            </button>
          </div>
        </div>
        <div class="info-popup-text">{{ text }}</div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import floatingTooltip from '@/utils/floatingTooltip';

export default {
  mixins: [floatingTooltip],
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      required: true
    },
    images: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentImageIndex: 0
    };
  },
  computed: {
    validImages() {
      return this.images.filter(image => typeof image === 'string' && image.trim() !== '');
    },
    currentImageSrc() {
      return this.validImages[this.currentImageIndex] || '';
    }
  },
  watch: {
    validImages() {
      this.currentImageIndex = 0;
    }
  },
  methods: {
    prevImage() {
      if (this.validImages.length > 1) {
        this.currentImageIndex =
          (this.currentImageIndex - 1 + this.validImages.length) % this.validImages.length;
      }
    },
    nextImage() {
      if (this.validImages.length > 1) {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.validImages.length;
      }
    }
  }
};
</script>

<style scoped src="@/styles/InfoTooltip.css">

</style>
